import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const router = new VueRouter({
    mode: 'hash',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: '/index'
        },
        {
            name: 'rule_dynamic_list',
            path: '/rule_dynamic_list',
            component: () => import('@pc/views/home/pages/rule_dynamic_list/rule_dynamic_list.vue')
        },
        {
            name: 'rule_dynamic_detail',
            path: '/rule_dynamic_detail',
            component: () => import('@pc/views/home/pages/rule_dynamic_detail/rule_dynamic_detail.vue')
        },
        {
            name: 'rule_list',
            path: '/rule_list',
            component: () => import('@pc/views/home/pages/rule_list/rule_list.vue'),
        },
        {
            name: 'rule_history',
            path: '/rule_history',
            component: () => import('@pc/views/home/pages/rule_history_list/rule_history_list.vue')
        },
        {
            name: 'rule_detail',
            path: '/rule_detail',
            component: () => import('@pc/views/home/pages/rule_detail/rule_detail.vue')
        },
        {
            name: 'index',
            path: '/index',
            component: () => import('@pc/views/home/pages/index/index.vue')
        },
        {
            name: 'test',
            path: '/test',
            component: () => import('@pc/views/home/pages/test_pipeline/test_pipeline.vue')
        }
    ]
})

export default router
